export const MIN_BALANCE_REQUIRED = 0;

export const MAX_AMOUNT_LENGTH_FOR_SHORT_LABEL = 19;

export const BALANCE_LABELS = {
  SHORT: 'Disponible:',
  LONG: 'Saldo Disponible:',
} as const;

export const TRANSACTION_ROUTE_NAME = 'transaction';

export const HOME_ROUTE_NAME = 'movements';
